import { FC } from 'react';

import { Badge, BadgeProps } from '@mantine/core';

const FeaturedBadge: FC<BadgeProps> = (props) => {
    return (
        <Badge className="gradient-cyan-green-background-light" c="gray.8" fw={600} size="sm" {...props}>
            Featured
        </Badge>
    );
};

export { FeaturedBadge };
